import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "flex w-full flex-col md:flex-row" }
const _hoisted_2 = { class: "hidden md:block bg-white border-2 border-gray-400 rounded-md p-4" }
const _hoisted_3 = { class: "flex justify-end mt-7" }
const _hoisted_4 = { class: "bg-white border-2 border-gray-400 rounded-md p-4" }
const _hoisted_5 = { class: "grid gap-4" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex justify-end mt-7" }
const _hoisted_8 = { class: "flex justify-end items-center md:flex-grow" }
const _hoisted_9 = {
  class: "md:hidden",
  style: {"height":"calc(100vh - 177px)"}
}
const _hoisted_10 = { class: "custom-title flex flex-col" }
const _hoisted_11 = { class: "ml-auto" }
const _hoisted_12 = { class: "flex items-center space-x-1" }
const _hoisted_13 = { class: "text-white" }
const _hoisted_14 = { style: {"height":"calc(100vh - 227px)","overflow-y":"auto"} }
const _hoisted_15 = {
  key: 0,
  class: "flex-grow"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "hidden md:block w-full" }
const _hoisted_18 = { class: "flex w-full justify-end mt-4" }
const _hoisted_19 = { class: "hidden md:block mr-3" }
const _hoisted_20 = { class: "md:hidden" }
const _hoisted_21 = { class: "flex flex-col md:flex-row gap-4" }
const _hoisted_22 = { class: "w-full md:w-1/2" }
const _hoisted_23 = { class: "w-full md:w-1/2" }
const _hoisted_24 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrganizationSelect = _resolveComponent("OrganizationSelect")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DepartmentSelect = _resolveComponent("DepartmentSelect")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_mian = _resolveComponent("el-mian")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_container, { style: {"height":"calc(100vh - 52px)"} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, {
          style: {"height":"auto"},
          class: "bg-gray-200 p-3 md:p-5"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_form, {
                  model: _ctx.searchForm,
                  "label-width": "auto",
                  "label-position": "top"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["grid gap-4", [
                                _ctx.loginUserRole === _ctx.ROLES.SYSTEM ? 'md:grid-cols-6' : 'md:grid-cols-5',
                            ]])
                    }, [
                      _withDirectives(_createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "組織"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_OrganizationSelect, {
                            modelValue: _ctx.searchForm.organization_id,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.organization_id) = $event)),
                            "is-search": true,
                            placeholder: "組織を選択"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM]
                      ]),
                      _withDirectives(_createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "部門"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DepartmentSelect, {
                            "organization-id": _ctx.searchForm.organization_id,
                            "is-search": true,
                            modelValue: _ctx.searchForm.department_id,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchForm.department_id) = $event)),
                            placeholder: "部門を選択",
                            onOrganizationIdChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchForm.organization_id = $event))
                          }, null, 8, ["organization-id", "modelValue"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead)]
                      ]),
                      _createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "ユーザー"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_UserSelect, {
                            "organization-id": _ctx.searchForm.organization_id,
                            "is-search": true,
                            modelValue: _ctx.searchForm.user_id,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchForm.user_id) = $event)),
                            placeholder: "ユーザーを選択"
                          }, null, 8, ["organization-id", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "開始日"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            "is-search": true,
                            modelValue: _ctx.searchForm.start_date,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchForm.start_date) = $event)),
                            type: "datetime",
                            placeholder: "開始日時を選択"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "終了日"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            "is-search": true,
                            modelValue: _ctx.searchForm.end_date,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchForm.end_date) = $event)),
                            type: "datetime",
                            placeholder: "終了日時を選択"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_el_button, {
                          class: "hidden md:block w-24",
                          type: "info",
                          onClick: _ctx.handleSearchButton
                        }, {
                          default: _withCtx(() => _cache[29] || (_cache[29] = [
                            _createTextVNode("検索")
                          ])),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ], 2)
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              _createVNode(_component_el_drawer, {
                class: "md:hidden bg-gray-200",
                modelValue: _ctx.drawer,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.drawer) = $event)),
                title: "検索",
                direction: "ttb",
                "with-header": false,
                size: "auto"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_form, {
                      model: _ctx.searchForm,
                      "label-width": "auto",
                      "label-position": "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _withDirectives(_createVNode(_component_el_form_item, {
                            class: "no-margin",
                            label: "組織"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_OrganizationSelect, {
                                modelValue: _ctx.searchForm.organization_id,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchForm.organization_id) = $event)),
                                "is-search": true,
                                placeholder: "組織を選択"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM]
                          ]),
                          _withDirectives(_createVNode(_component_el_form_item, {
                            class: "no-margin",
                            label: "部門"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DepartmentSelect, {
                                "organization-id": _ctx.searchForm.organization_id,
                                "is-search": true,
                                modelValue: _ctx.searchForm.department_id,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchForm.department_id) = $event)),
                                placeholder: "部門を選択",
                                onOrganizationIdChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.searchForm.organization_id = $event))
                              }, null, 8, ["organization-id", "modelValue"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead)]
                          ]),
                          _createVNode(_component_el_form_item, {
                            class: "no-margin",
                            label: "開始日"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                "is-search": true,
                                modelValue: _ctx.searchForm.start_date,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.searchForm.start_date) = $event)),
                                type: "datetime",
                                placeholder: "開始日時を選択"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            class: "no-margin",
                            label: "終了日"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                "is-search": true,
                                modelValue: _ctx.searchForm.end_date,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.searchForm.end_date) = $event)),
                                type: "datetime",
                                placeholder: "終了日時を選択"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_el_form_item, {
                              class: "no-margin flex-grow",
                              label: "ユーザー"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_UserSelect, {
                                  "organization-id": _ctx.searchForm.organization_id,
                                  "is-search": true,
                                  modelValue: _ctx.searchForm.user_id,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.searchForm.user_id) = $event)),
                                  placeholder: "ユーザーを選択"
                                }, null, 8, ["organization-id", "modelValue"])
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_el_button, {
                                class: "md:hidden ml-3",
                                type: "info",
                                onClick: _ctx.handleSearchButton,
                                circle: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => _cache[30] || (_cache[30] = [
                                      _createElementVNode("span", { class: "material-symbols-outlined" }, "manage_search", -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_button, {
                  class: "custom-icon-btn md:hidden",
                  type: "info",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.drawer = true)),
                  circle: ""
                }, {
                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                    _createElementVNode("span", { class: "material-symbols-outlined" }, " manage_search ", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  class: "custom-icon-btn",
                  type: "info",
                  onClick: _ctx.handleExportButton,
                  circle: ""
                }, {
                  default: _withCtx(() => _cache[32] || (_cache[32] = [
                    _createElementVNode("span", { class: "material-symbols-outlined" }, " download_2 ", -1)
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_mian, { style: {"padding-bottom":"20px"} }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[36] || (_cache[36] = _createElementVNode("span", null, "履歴マスタ", -1)),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _cache[35] || (_cache[35] = _createElementVNode("span", { class: "text-white" }, "ソート:", -1)),
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleSort('action_time'))),
                      class: _normalizeClass(['mobile-sort-btn', _ctx.sortField === 'action_time' ? 'active' : ''])
                    }, {
                      default: _withCtx(() => _cache[33] || (_cache[33] = [
                        _createTextVNode(" 日時 ")
                      ])),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleSort('user_name'))),
                      class: _normalizeClass(['mobile-sort-btn', _ctx.sortField === 'user_name' ? 'active' : ''])
                    }, {
                      default: _withCtx(() => _cache[34] || (_cache[34] = [
                        _createTextVNode(" ユーザー ")
                      ])),
                      _: 1
                    }, 8, ["class"]),
                    _createElementVNode("span", _hoisted_13, "アイテム数: " + _toDisplayString(_ctx.mTotalRecords), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mTableData, (item) => {
                  return (_openBlock(), _createBlock(_component_el_card, {
                    style: {"border":"1px solid #d1d5db","border-radius":"0px"},
                    key: item.history_id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { align: "middle" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 2 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                class: "w-8 h-16",
                                type: "info",
                                style: {"background-color":"#b7b7b7"},
                                text: "",
                                bg: "",
                                onClick: ($event: any) => (_ctx.handleDetailButton(item))
                              }, {
                                default: _withCtx(() => _cache[37] || (_cache[37] = [
                                  _createElementVNode("span", null, [
                                    _createTextVNode("詳"),
                                    _createElementVNode("br"),
                                    _createTextVNode("細")
                                  ], -1)
                                ])),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, {
                            span: 20,
                            class: "ml-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_row, { align: "middle" }, {
                                default: _withCtx(() => [
                                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(item.organization_name), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(item.department_name), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("div", null, _toDisplayString(item.user_name), 1),
                              _createElementVNode("div", null, _toDisplayString(item.action), 1),
                              _createElementVNode("div", null, _toDisplayString(_ctx.moment(item.action_time).format('YYYY-MM-DD HH:mm:ss')), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_17, [
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                data: _ctx.mTableData,
                height: "calc(100vh - 260px)"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "履歴確認",
                    width: "100",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_button, {
                        class: "w-12",
                        type: "info",
                        style: {"background-color":"#b7b7b7"},
                        text: "",
                        bg: "",
                        onClick: ($event: any) => (_ctx.handleDetailButton(scope.row))
                      }, {
                        default: _withCtx(() => _cache[38] || (_cache[38] = [
                          _createElementVNode("span", null, "詳細", -1)
                        ])),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  }),
                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 0,
                        prop: "organization_name",
                        label: "所属組織",
                        width: "200"
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "flex items-center cursor-pointer whitespace-nowrap",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleSort('organization_name')))
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('organization_name')), 1),
                            _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'organization_name' }])
                                }, _toDisplayString(_ctx.getSortIcon('organization_name')), 3)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead))
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 1,
                        prop: "department_name",
                        label: "所属部門",
                        width: "160"
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "flex items-center cursor-pointer whitespace-nowrap",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleSort('department_name')))
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('department_name')), 1),
                            _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'department_name' }])
                                }, _toDisplayString(_ctx.getSortIcon('department_name')), 3)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_table_column, {
                    prop: "user_name",
                    label: "操作者名",
                    width: "140"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer whitespace-nowrap",
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleSort('user_name')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('user_name')), 1),
                        _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'user_name' }])
                            }, _toDisplayString(_ctx.getSortIcon('user_name')), 3)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "action",
                    label: "操作内容"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "action_time",
                    label: "操作日",
                    width: "160"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer whitespace-nowrap",
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleSort('action_time')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('action_time')), 1),
                        _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'action_time' }])
                            }, _toDisplayString(_ctx.getSortIcon('action_time')), 3)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(_ctx.moment(scope.row.action_time).format('YYYY-MM-DD HH:mm:ss')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])), [
                [_directive_loading, _ctx.loading]
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_el_pagination, {
                  "current-page": _ctx.mCurrentPage,
                  "onUpdate:currentPage": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.mCurrentPage) = $event)),
                  "page-size": _ctx.mPageSize,
                  "onUpdate:pageSize": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.mPageSize) = $event)),
                  "page-sizes": [10, 20, 50, 100],
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _ctx.mTotalRecords,
                  onSizeChange: _ctx.handleSizeChange,
                  onCurrentChange: _ctx.handleCurrentChange
                }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_el_pagination, {
                  layout: "prev, pager, next",
                  total: _ctx.mTotalRecords,
                  onCurrentChange: _ctx.handleCurrentChange
                }, null, 8, ["total", "onCurrentChange"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      class: "custom-dialog",
      "modal-class": "custom-dialog-modal",
      style: {"max-width":"800px"},
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
      title: "詳細",
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.dialogFormVisible = false))
          }, {
            default: _withCtx(() => _cache[39] || (_cache[39] = [
              _createTextVNode(" 確認 ")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_el_form, {
              model: _ctx.form,
              ref: "formRef",
              "label-width": "100px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "所属組織",
                  prop: "organization_name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.organization_name,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.organization_name) = $event)),
                      autocomplete: "off",
                      readonly: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "所属部門",
                  prop: "department_name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.department_name,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.department_name) = $event)),
                      autocomplete: "off",
                      readonly: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "操作者名",
                  prop: "user_name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.user_name,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.user_name) = $event)),
                      autocomplete: "off",
                      readonly: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "操作内容",
                  prop: "action"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.action,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.action) = $event)),
                      autocomplete: "off",
                      readonly: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "操作日",
                  prop: "action_time"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.action_time,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.action_time) = $event)),
                      autocomplete: "off",
                      readonly: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_el_form, {
              model: _ctx.form,
              ref: "formRef",
              "label-width": "100px",
              "label-position": "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "詳細内容",
                  prop: "other_info"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      "model-value": _ctx.detailText,
                      autocomplete: "off",
                      type: "textarea",
                      autosize: { minRows: 5 },
                      readonly: ""
                    }, null, 8, ["model-value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}